import React, { useCallback, memo, useMemo, useEffect } from 'react'
import { hex } from 'utils/hex'

import Table from 'components/CommonUI/Table'

import { devicesIconComponent } from 'constants/deviceTypeConstants'
import {
  TOTAL_ID_PREFIX,
  sortDirectionConstant,
} from 'constants/tableConstants'
import { filterIdPrefix } from '../constants'
import {
  getConsamptionDataDeviceSelector,
  getSelectedDeviceSelector,
} from 'redux/reducers/equipments'
import { useShallowEqualSelector } from 'custom-hooks'
import { useEquipmentContext } from '../EquipmentContainer'

const TableSection = () => {
  const dataDevices = useShallowEqualSelector(getConsamptionDataDeviceSelector)
  const selectedDevice = useShallowEqualSelector(getSelectedDeviceSelector)

  const isCountCellTableNeed = selectedDevice.value?.includes(
    filterIdPrefix.device
  )

  const { setSelectedDevices } = useEquipmentContext()

  const dataWithCheckedState = useMemo(() => {
    return dataDevices.map((device) => ({
      ...device,
      checked: device.id.includes(TOTAL_ID_PREFIX),
      color: device.color,
    }))
  }, [dataDevices])

  const handleCheckBox = useCallback(
    (values) => {
      const _data = values?.filter((r) => r.checked) || []
      setSelectedDevices(_data)
    },
    [setSelectedDevices]
  )

  useEffect(() => {
    const _data = dataWithCheckedState?.filter((r) => r.checked) || []
    setSelectedDevices(_data)
  }, [dataWithCheckedState, setSelectedDevices])

  const isCheckBoxNeed = !!(
    dataWithCheckedState.filter((i) => !i.id.includes(TOTAL_ID_PREFIX)).length -
    1
  )

  return (
    <div className="equipment_table_container">
      <Table
        data={dataWithCheckedState}
        isSelectAction={isCheckBoxNeed}
        selectComponent="checkbox"
        handleSelectChange={handleCheckBox}
        idKey="id"
        checkedKey="checked"
        defaultSortField="consumption"
        defaultSortDirection={sortDirectionConstant.DESC}
      >
        <Table.Column
          dataField="name"
          caption="DEVICE NAME"
          cellRender={(props) => {
            return <DeviceNameCell {...props} />
          }}
          isSort
        />
        {isCountCellTableNeed ? (
          <Table.Column dataField="count" caption="DEVICES" isSort />
        ) : null}
        <Table.Column
          dataField="consumption"
          caption="CONSUMPTION"
          isSort
          cellRender={(props) => {
            return <ConsamptionCell {...props} />
          }}
        />
        <Table.Column
          dataField="estimated_cost"
          caption="ESTIMATED COSTS"
          valuesStringType="AED"
          valuesType="substring"
          isSort
        />
        <Table.Column
          dataField="energy_intensity"
          caption="ENERGY INTENSITY"
          valuesStringType="kWh/m&#178;"
          valuesType="substring"
          isSort
        />
      </Table>
    </div>
  )
}

const DeviceNameCell = memo((props) => {
  const { data } = props
  const Icon = devicesIconComponent[data.icon]?.ComponentIcon

  const _color = data?.color || '#000000'

  return (
    <>
      {!!Icon && (
        <span
          className="device_icon"
          style={{
            backgroundColor: hex(_color, 15),
          }}
        >
          <Icon color={_color} />
        </span>
      )}
      {data.name}
    </>
  )
})

const ConsamptionCell = memo(({ data }) => {
  const totalRowClassName = data.id.includes(TOTAL_ID_PREFIX) ? 'total' : ''

  return (
    <span className={`consampion_cell_content ${totalRowClassName}`}>
      {data.consumption}{' '}
      <span className="consampion_cell_unit">
        kWh{' '}
        <span className="consampion_cell_percentage">{data.percentage}%</span>
      </span>
    </span>
  )
})

export default memo(TableSection)
